import {ModuleWithProviders, NgModule} from '@angular/core';
import {BROWSER_GLOBALS_PROVIDERS} from './utils/browser-globals';
import {ExgMapLazyAPILoader, ExgMapLazyAPILoaderConfigLiteral, EXG_MAP_LAZY_API_CONFIG, ExgMapAPILoader} from './services';
import {
  ExgMapFullscreenControlDirective,
  ExgMapComponent,
  ExgMapPanControlDirective,
  ExgMapRotateControlDirective,
  ExgMapScaleControlDirective,
  ExgMapStreetViewControlDirective,
  ExgMapTypeControlDirective,
  ExgMapZoomControlDirective,
  ExgMapMarkerDirective,
  ExgMapInfoWindowComponent,
  ExgMapCircleComponent,
  ExgMapRectangleComponent,
  ExgMapPolylineComponent,
  ExgMapPolylineIconDirective,
  ExgMapPolylinePointDirective,
  ExgMapPolygonComponent,
  ExgMapTransitLayerDirective,
  ExgMapBicyclingLayerDirective,
  ExgMapDataLayerComponent,
  ExgMapKmlLayerComponent,
  ExgMapDrawingManagerDirective,
  ExgMapDrawingManagerTriggerDirective,
  ExgMapMarkerClusterDirective, ExgMapHeatmapLayerDirective, ExgMapDirectionDirective
} from './directives';

export function coreDirectives(): any[] {
  return [
    ExgMapFullscreenControlDirective,
    ExgMapTypeControlDirective,
    ExgMapPanControlDirective,
    ExgMapRotateControlDirective,
    ExgMapScaleControlDirective,
    ExgMapStreetViewControlDirective,
    ExgMapZoomControlDirective,
    ExgMapMarkerDirective,
    ExgMapComponent,
    ExgMapInfoWindowComponent,
    ExgMapCircleComponent,
    ExgMapRectangleComponent,
    ExgMapPolylineComponent,
    ExgMapPolylineIconDirective,
    ExgMapPolylinePointDirective,
    ExgMapPolygonComponent,
    ExgMapTransitLayerDirective,
    ExgMapBicyclingLayerDirective,
    ExgMapDataLayerComponent,
    ExgMapKmlLayerComponent,
    ExgMapDrawingManagerDirective,
    ExgMapDrawingManagerTriggerDirective,
    ExgMapMarkerClusterDirective,
    ExgMapHeatmapLayerDirective,
    ExgMapDirectionDirective
  ];
}

@NgModule({declarations: coreDirectives(), exports: coreDirectives()})
export class ExcMapV2Module {
  /**
   * Method for GoogleMaps API Loader. You have to set up an api key for usage of google maps.
   * ExcMapV2Module supports libraries 'drawing' and 'visualization' out of the box.
   *
   * @param lazyMapsAPILoaderConfig ExgMapLazyAPILoaderConfigLiteral
   *
   * @example
   *
   *  ExcMapV2Module.forRoot({
   *       apiKey: '<<Your API KEY>>',
   *       libraries: ['drawing', 'visualization']
   *     })
   */
  static forRoot(lazyMapsAPILoaderConfig?: ExgMapLazyAPILoaderConfigLiteral): ModuleWithProviders<ExcMapV2Module> {
    return {
      ngModule: ExcMapV2Module,
      providers: [
        ...BROWSER_GLOBALS_PROVIDERS, {provide: ExgMapAPILoader, useClass: ExgMapLazyAPILoader},
        {provide: EXG_MAP_LAZY_API_CONFIG, useValue: lazyMapsAPILoaderConfig},
      ],
    };
  }
}
